<template>
  <v-app id="inspire" dark>
    <loading />
    <snackbar />
    <template v-if="Boolean(Object.keys(authUser).length)">
      <v-navigation-drawer v-model="drawerRight" app clipped temporary right>
        <user-menu
          v-bind:drawerRight="drawerRight"
          @drawerRight="updateDrawerRight"
        ></user-menu>
      </v-navigation-drawer>

      <v-app-bar app clipped-right color="info" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ titlePage }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large v-bind="attrs" v-on="on">
              <v-badge :content="notificaciones.length" :value="notificaciones.length" color="red" overlap>
                <v-icon>mdi-bell-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <span>
            <v-list v-for="(item, index) in notificaciones" :key="index" max-width="400px" class="pb-1 pt-1">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">{{ item.icono}}</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < notificaciones.length - 1" :key="index"></v-divider>
            </v-list>
          </span>
        </v-menu>

        <v-btn icon large @click.stop="drawerRight = !drawerRight">
          <v-avatar>
            <v-icon>mdi-account-circle-outline</v-icon>
          </v-avatar>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" app>
        <app-menu></app-menu>
      </v-navigation-drawer>

      <v-navigation-drawer v-model="left" fixed temporary></v-navigation-drawer>
      <v-btn absolute dark fab top right color="pink">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <!-- <v-main style="overflow-y: auto; height: 100vh;"> -->
      <v-main>
        <v-container class="fill-height" fluid>
          <!-- {{ route.fullPath }} -->
          <!-- <transition name="view"> -->
          <router-view></router-view>
          <!-- </transition> -->
        </v-container>
      </v-main>

      <v-navigation-drawer
        v-model="right"
        fixed
        right
        temporary
      ></v-navigation-drawer>
    </template>
    <router-view v-else />
  </v-app>
</template>

<script>
import router from "./router";
import AppMenu from "./components/menus/AppMenu";
import UserMenu from "./components/menus/UserMenu";
import { mapState } from "vuex";
import Loading from "./components/utils/Loading";
import Snackbar from "./components/utils/Snackbar";
export default {
  props: {
    source: String,
  },
  data: () => ({
    titlePage: "",
    drawer: null,
    drawerRight: false,
    right: false,
    left: false,
    messages: 0,
  }),
  components: {
    "app-menu": AppMenu,
    "user-menu": UserMenu,
    loading: Loading,
    snackbar: Snackbar,
  },
  mounted() {
    if (localStorage.getItem("themeDark") != null) {
      if (localStorage.getItem("themeDark") === "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    }
    this.titlePage = this.getTitlePage();
  },
  methods: {
    getTitlePage() {
      this.titlePage = router.history.current.meta.title;
      return this.titlePage;
    },
    updateDrawerRight(valor) {
      this.drawerRight = valor;
    },
  },
  computed: {
    ...mapState("login", ["authUser"]),
    ...mapState("notificaciones", ["notificaciones"]),
  },
  watch: {
    $route(to, from) {
      this.titlePage = this.getTitlePage();
    },
  },
};
</script>
<style>
html {
  overflow-y: auto !important;
}

.v-footer {
  padding: 2px 16px !important;
  font-size: 12px;
}

/* .view-enter-active, .view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
  }
  .view-enter-active {
    transition-delay: 0.5s;
  }
  .view-enter {
    opacity: 0;
    transform: translateY(100px);
  }
  .view-enter-to {
    opacity: 1;
    transform: translateY(0px);
  }
  .view-leave {
    opacity: 1;
    transform: translateY(0px);
  }
  .view-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  } */
</style>
